import { IconRandom } from "components/icons";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";

export const IconButtonRandom: React.FC<MprcIconButtonProps> = ({ ...rest }) => {
    return (
        <MprcIconButton
            {...rest}
        >
            <IconRandom fixedWidth />
        </MprcIconButton>
    );
};
